export const iconFontAwesomeLogisticsRoadBridge = (
	<i className="fa-solid fa-road-bridge"></i>
);
